import axios from 'axios';
import { baseUrl } from '../utils/constants';

export const generateForm = async (job) => axios.post(
  `${baseUrl()}jobs/generateForm/`,
  job,
  {
    responseType: 'blob',
    withCredentials: true,
  },
);

export const getJobFromHash = async (hash) => axios.get(
  `${baseUrl()}jobs/hash/${hash}`, { withCredentials: true },
);

export const getJobFromId = async (id) => axios.get(
  `${baseUrl()}jobs/id/${id}`, { withCredentials: true },
);

export const getJobFromCode = async (hash) => axios.get(
  `${baseUrl()}jobs/code/${hash}`, { withCredentials: true },
);

export const getJobFromArtCode = async (hash) => axios.get(
  `${baseUrl()}jobs/artCode/${hash}`, { withCredentials: true },
);

export const jobTable = async (search = '', page = 1, pageSize = 10) => axios.get(
  `${baseUrl()}r/jobs/?page=${page}&pageSize=${pageSize}${search ? `&search=${search}` : ''}`, { withCredentials: true },
);

export const createJob = async (payload) => axios.post(
  `${baseUrl()}r/jobs/`, payload, { withCredentials: true },
);

export const updateJob = async (payload) => axios.patch(
  `${baseUrl()}r/jobs/${payload.id}/`, payload, { withCredentials: true },
);

export const getJob = async (jobId) => axios.get(
  `${baseUrl()}r/jobs/${jobId}/`, { withCredentials: true },
);

export const getManifest = async (submissionInfo) => axios.post(
  `${baseUrl()}jobs/manifest`, submissionInfo, { withCredentials: true },
);

export const generateInvoice = async (jobHash) => axios.get(
  `${baseUrl()}jobs/generateInvoice/${jobHash}`, { responseType: 'blob', withCredentials: true },
);

export const generateQrcode = async (jobHash) => axios.get(
  `${baseUrl()}jobs/generateQrcode/${jobHash}`, { responseType: 'blob', withCredentials: true },
);

export const generateArtQrcode = async (jobHash) => axios.get(
  `${baseUrl()}jobs/generateArtQrcode/${jobHash}`, { responseType: 'blob', withCredentials: true },
);

export const changeToHasPaid = async (id) => axios.post(
  `${baseUrl()}jobs/markHasPaid/${id}`, id, { withCredentials: true },
);

export const deleteJob = async (id) => axios.post(
  `${baseUrl()}jobs/deleteJob/${id}`, id, { withCredentials: true },
);
